import React, { ForwardRefRenderFunction, forwardRef, useImperativeHandle, useState } from "react";

import { Grid, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Select } from "../../../../../../../../../../components/Form";
import Modal from "../../../../../../../../../../components/Generic/Modal";
import { TypeModal } from "../../enum";

interface AssignModalProps {}

export interface AssignModalHandle {
  setOpenModalHandle: (title: string, type: string) => void;
}

const AssignModal: ForwardRefRenderFunction<AssignModalHandle, AssignModalProps> = (props, ref) => {
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>("");
  const [modalTitle, setModalTitle] = useState<string>("");

  const setOpenModalHandle = (title: string, type: string) => {
    setOpenModal(true);
    setModalType(type);
    setModalTitle(title);
  };

  useImperativeHandle(ref, () => ({
    setOpenModalHandle,
  }));

  return (
    <Modal
      open={openModal}
      title={modalTitle}
      data-cy="assignModal"
      handleClose={() => setOpenModal(false)}
      showActionButtons
      actionButtonProps={{
        onSave: () => setOpenModal(false),
        onCancel: () => setOpenModal(false),
      }}
    >
      <Grid container direction="row" alignItems="center" spacing={2}>
        {modalType === TypeModal.LOCATION ? (
          <React.Fragment>
            <Grid item xs={12} sm={6}>
              <Select label={translate("section")}>
                <MenuItem>{translate("select")}</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Select label={translate("location")}>
                <MenuItem>{translate("select")}</MenuItem>
              </Select>
            </Grid>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Grid item xs={12} sm={6}>
              <Select label={translate("type")}>
                <MenuItem>{translate("select")}</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Select label={translate("unit")}>
                <MenuItem>{translate("select")}</MenuItem>
              </Select>
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    </Modal>
  );
};

export default forwardRef(AssignModal);
